import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import { PurchasedProvider } from './PurchasedProvider';
import * as iconSources from './iconSources';
var ICONS_URL_PREFIX = 'https://images-wixmp-fe53c9ff592a4da924211f23.wixmp.com';
export var PurchasedNounProvider = /*#__PURE__*/function (_PurchasedProvider) {
  _inheritsLoose(PurchasedNounProvider, _PurchasedProvider);

  function PurchasedNounProvider() {
    return _PurchasedProvider.call(this, iconSources.PURCHASED_NOUN_SOURCE) || this;
  }

  var _proto = PurchasedNounProvider.prototype;

  _proto.hasDefault = function hasDefault() {
    return true;
  };

  _proto.searchIcons = /*#__PURE__*/function () {
    var _searchIcons = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$import, wixLogosData;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return import(
              /* webpackChunkName: "wixLogosData" */
              '../../data/wixLogosData.js');

            case 2:
              _yield$import = _context.sent;
              wixLogosData = _yield$import.wixLogosData;
              return _context.abrupt("return", wixLogosData.map(function (icon) {
                var id = icon.id,
                    url = icon.url;
                return {
                  id: id,
                  iconUrl: ICONS_URL_PREFIX + url
                };
              }).map(function (icon) {
                return _objectSpread(_objectSpread({}, icon), {}, {
                  randomId: Math.random()
                });
              }).sort(function (i1, i2) {
                return i1.randomId - i2.randomId;
              }).map(function (sortedIcon) {
                delete sortedIcon.randomId;
                return sortedIcon;
              }));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function searchIcons() {
      return _searchIcons.apply(this, arguments);
    }

    return searchIcons;
  }();

  return PurchasedNounProvider;
}(PurchasedProvider);